export default __webpack_public_path__ + "static/media/living_room.da30bbcb.jpg";